<template>
  <div>
    <div id="experience" class="row single-info">
      <div class="col-12 info-details" align="left">
        <div class="resume-view-header">{{ info.project_name }}</div>
        <div v-if="info.project_url" @click="openProjectUrl" style="cursor:pointer">{{ info.project_url }}</div>
        <div>
          {{ calculateDuration() }}
        </div>
        <div class="resume-view-details">{{ info.project_description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "projects-card",
  components: {},
  props: {
    edu: Object,
    index: Number,
  },
  data: function () {
    return {
      info: this.edu,
    };
  },
  methods: {
    calculateDuration: function () {
      const self = this;
      let start = self.info.begin_date;
      let end;
      if (self.info.is_working) {
        end = "Present";
      } else {
        end = self.info.end_date;
      }
      return start + " - " + end;
    },
    openProjectUrl() {
      const self = this;
      if (
        self.info.project_url.includes("https://") ||
        self.info.project_url.includes("http://")
      ) {
        window.open(self.info.project_url, "_blank");
      } else {
        window.open("https://" + self.info.project_url, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.image-wrapper {
  text-align: left;
  margin-top: 1rem;
}
.num-wrapper {
  color: #3d4249;
  border: 0.1rem solid #3d4249;
  border-radius: 50%;
  padding: 0.1rem 0.6rem;
}
.single-info {
  padding: 1rem 0;
}
.info-details {
  padding: 0;
  text-align: left;
}
.univ {
  font-size: 16px;
  letter-spacing: 0;
}
.degree {
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 0;
}
.score {
  color: #808080;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0;
}
</style>
